<template>
  <v-container fluid class="px-12 py-4" v-if="loadingComplete">
    <v-row>
      <v-col cols="8">
        <breadcrumbs></breadcrumbs>
        <h1>Departments</h1>
      </v-col>
      <v-col cols="4">
        <div class="text-right">
          <v-btn
            :disabled="structureIsLocked"
            @click="navigateToCreate"
            class="mt-3"
            color="primary"
            outlined
            v-if="departmentPermission.create"
          >
            Add
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-divider class="mb-4"></v-divider>
    <v-card outlined class="mt-10">
      <v-card-text>
        <v-data-table
          :headers="departmentHeaders"
          :items="departmentList"
          item-key="departmentId"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <router-link
                  :to="{
                    name: 'departmentEdit',
                    params: { id: item.departmentId },
                    query: { redirect: 'structureChart' },
                  }"
                  >{{ item.departmentNumber }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{
                    name: 'departmentEdit',
                    params: { id: item.departmentId },
                    query: { redirect: 'structureChart' },
                  }"
                  >{{ item.name }}</router-link
                >
              </td>
              <td>{{ `${item.abbreviation}`.toUpperCase() }}</td>
              <td>{{ formatTimestamp(item.created) }}</td>
              <td>{{ (getUserById(item.createdBy) || {}).email }}</td>
              <td class="text-right">
                <DeleteFkEntityDialog
                  :disabled="structureIsLocked"
                  :fkEntityId="item.departmentId"
                  fkEntityName="department"
                  :fkEntityLabel="item.name"
                ></DeleteFkEntityDialog>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import { formatTimestamp } from "@/lib/componentUtil";

import Breadcrumbs from "@/views/Breadcrumbs";
import DeleteFkEntityDialog from "@/components/DeleteFkEntityDialog";

export default {
  components: {
    Breadcrumbs,
    DeleteFkEntityDialog,
  },
  computed: {
    structureIsLocked() {
      return this.getStructureStatus;
    },
    ...mapGetters({
      filterDepartmentList: "department/filterByAttributeValue",
      getStructureStatus: "organizationStatus/getStructureStatus",
    }),
    departmentList() {
      const list = this.filterDepartmentList("locationId", this.locationId);
      return list;
    },
    locationId() {
      return parseInt(this.$route.params.locationId, 10);
    },
    ...mapGetters({
      getUserById: "user/getById",
    }),
    ...mapState({
      departmentPermission: state => state.session.user.permission.department,
      location: state => state.location.record,
      locationList: state => state.location.list,
      organization: state => state.organization.record,
      organizationId: state => state.session.user.organizationId,
    }),
  },
  async created() {
    try {
      await Promise.all([
        this.getDepartmentList(),
        this.getLocation(this.locationId),
        this.getOrganization(this.organizationId),
        this.getUserList({ reload: false }),
      ]);
    } catch (e) {
      console.error(e);
    }
    this.loadingComplete = true;
  },
  data() {
    return {
      departmentHeaders: [
        {
          text: "Deptartment Number",
          align: "left",
          sortable: true,
          value: "departmentId",
          width: "10%",
        },
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name",
          width: "20%",
        },
        {
          text: "Abbreviation",
          align: "left",
          sortable: false,
          value: "abbreviation",
          width: "10%",
        },
        {
          text: "Created on",
          align: "left",
          sortable: false,
          value: "created",
          width: "20%",
        },
        {
          text: "Created by",
          align: "left",
          sortable: false,
          value: "createdBy",
          width: "35%",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "actions",
          width: "10%",
        },
      ],
      loadingComplete: false,
    };
  },
  methods: {
    ...mapActions({
      getDepartmentList: "department/list",
      getLocation: "location/get",
      getLocationList: "location/list",
      getOrganization: "organization/getByOrganizationId",
      getUserList: "user/list",
    }),
    navigateToCreate() {
      this.$router.push({
        name: "departmentCreate",
        query: { redirect: "structureChart" },
      });
    },
    formatTimestamp,
  },
};
</script>
